import React from "react";
import { useQuery } from "@apollo/react-hooks";
import nationalities from "i18n-nationality";
import lookup from "country-code-lookup";

import Layout from "components/Layout";
import DataTable, { formatData, mapData } from "components/DataTable";
import TreeMap from "components/chart/TreeMap";
import GeoChart from "components/chart/GeoChart";
import Flag from "components/Flag";
import Scrollable from "components/Scrollable";
import withAuth from "components/withAuth";
import { H2, Section } from "styles";
import { ETHNICITY } from "queries";

nationalities.registerLocale(require("i18n-nationality/langs/en.json"));

function Ethnicity() {
  const { data: { ethnicities } = { ethnicities: [] } } = useQuery(ETHNICITY);

  const names = nationalities.getNames("en");

  const format = (item: string) => <Flag item={item} />;

  const data = formatData(ethnicities, false, format);

  const byIso = {};

  Object.entries(ethnicities)
    .map(([ethnicity, count]) => ({
      [names[ethnicity]]: count,
    }))
    .map((item) => Object.assign(byIso, item));

  const chartData = mapData(byIso);

  const countryData = Object.entries(
    ethnicities
  ).map(([ethnicity, count]: any) => [lookup.byIso(ethnicity).country, count]);

  countryData.unshift(["Ethnicity", "Count"]);

  return (
    <Layout>
      <Section>
        <H2>Contacts by Ethnicity</H2>
        <DataTable
          headers={["", "Ethnicity", "Count"]}
          data={data}
          link="/contact/ethnicity/"
        />
      </Section>
      <Section>
        <H2>Tree Map</H2>
        <Scrollable>
          <TreeMap data={chartData} />{" "}
        </Scrollable>
      </Section>
      <Section>
        <H2>Geo Chart</H2>
        <Scrollable>
          <GeoChart data={countryData} />{" "}
        </Scrollable>
      </Section>
    </Layout>
  );
}

export default withAuth(Ethnicity);
